import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IFreeVisitsDto, IPointsDto, IPointsSummaryDto } from 'src/app/contracts';
import { Api } from 'src/app/core/common/api';
import { IApiOptions } from 'src/app/core/contracts';

@Injectable({ providedIn: 'root' })
export class PointsData {
  private api = inject(Api);

  private summary = new BehaviorSubject<IPointsSummaryDto>({ points: 0, price: 0 } as IPointsSummaryDto);
  public get summary$() {
    return this.summary.asObservable();
  }
  public getSummary(forceUpdate?: boolean, options?: IApiOptions): Promise<IPointsSummaryDto> {
    return new Promise(resolve => {
      if (forceUpdate) {
        this.api
          .get<IPointsSummaryDto>('points/summary', options)
          .pipe(
            catchError(err => {
              resolve(this.summary.getValue());
              return throwError(() => err as unknown);
            })
          )
          .subscribe((summary: IPointsSummaryDto) => {
            this.summary.next(summary);
            resolve(summary);
          });
      } else {
        resolve(this.summary.getValue());
      }
    });
  }
  public getPoints(): Observable<IPointsDto[]> {
    return this.api.get('points');
  }
  public getFreeVisits(): Observable<IFreeVisitsDto[]> {
    return this.api.get('points/free-visits');
  }

  public dispose() {
    this.summary.next({ points: 0, price: 0 } as IPointsSummaryDto);
    return Promise.resolve();
  }
}
